import { graphql } from '@/gql';
import type { AssignAbTestPerStrategyMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';
import _ from 'lodash';

export const assignAbTestPerStrategy = async (variables: AssignAbTestPerStrategyMutationVariables) => {
  const response = await mutationExecute({
    variables,
    mutation: graphql(`
      mutation assignAbTestPerStrategy($abTestName: String!, $associatedObjectId: String!, $associatedObjectType: String!) {
        assignAbTestPerStrategy(
          abTestName: $abTestName
          associatedObjectId: $associatedObjectId
          associatedObjectType: $associatedObjectType
        ) {
          __typename
          groupLabel
          groupType
        }
      }
    `),
  });

  if (response.errors?.length) {
    throw new Error(util.getGraphqlError({ graphQLErrors: response.errors }, false), { cause: response });
  }

  return response.data?.assignAbTestPerStrategy;
};
